import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Button, Col, Form, Modal, Row, Spinner } from "react-bootstrap";
import NumberFormat from "react-number-format";

//
import { Formik } from "formik";
import * as yup from "yup";

//
import Point from "../../../assets/img/point.png";

//
import { chargePoint } from "../../../redux/features/coins/actions";

function ChargePointsModal({ configs }) {
  const schema = yup.object().shape({
    amount: yup.string().required(),
  });

  const [amount, setAmount] = useState(0);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const willGet = () => {
    let ratio = +configs.POINT_TO_USD_RATIO;
    return +amount * ratio;
  };

  const submitForm = async (e) => {
    const usdAmount = +e.amount;
    const minimum = +configs.MINIMUM_USD_FOR_CHARGE_POINT_WALLET;

    if (usdAmount >= minimum) {
      // start loading
      setLoading(true);

      // request
      await chargePoint(e).then((res) => {
        if (res) {
          window.location = res;
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  return (
    <>
      <span className="text-warning pointer" onClick={() => setShow(true)}>
        (Charge here)
      </span>

      <Modal
        centered
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        id="charge-point-modal"
      >
        <Modal.Header closeButton>
          <h5>Charge Points</h5>
        </Modal.Header>

        <Modal.Body>
          <Formik
            validationSchema={schema}
            onSubmit={submitForm}
            initialValues={{
              amount: "",
            }}
          >
            {({ handleSubmit, handleChange, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                {/* USD Amount */}
                <Form.Group
                  className="form-group"
                  controlId="validationFormik0"
                >
                  <Form.Label>USD Amount</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    placeholder="Type here..."
                    className="form-control"
                    onChange={(e) => {
                      handleChange(e);
                      setAmount(e.target.value);
                    }}
                    autoComplete="off"
                    isInvalid={
                      (touched.amount && !!errors.amount) ||
                      (touched.amount &&
                        +amount < +configs.MINIMUM_USD_FOR_CHARGE_POINT_WALLET)
                    }
                  />
                </Form.Group>

                <div className="info">
                  <p>
                    1 USD
                    <span>
                      <NumberFormat
                        value={+configs.POINT_TO_USD_RATIO}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalSeparator="."
                      />
                      <span className="ms-1">Points</span>
                    </span>
                  </p>
                  <p>
                    Minimum Amount
                    <span>
                      <NumberFormat
                        value={+configs.MINIMUM_USD_FOR_CHARGE_POINT_WALLET}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalSeparator="."
                      />
                      <span className="ms-1">USD</span>
                    </span>
                  </p>
                </div>
                <p>
                  You will get
                  <span className={willGet() == 0 ? "text-danger" : ""}>
                    <img src={Point} alt="point icon" />
                    <NumberFormat
                      value={willGet()}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalSeparator="."
                      className={willGet() == 0 ? "text-danger" : ""}
                    />
                    <span
                      className={`ms-1 ${willGet() == 0 ? "text-danger" : ""}`}
                    >
                      Points
                    </span>
                  </span>
                </p>

                <div className="actions">
                  <Button variant="info" type="submit" size="lg">
                    Charge
                    {loading && (
                      <div className="spinner-holder">
                        <Spinner animation="border" variant="white" size="sm" />
                      </div>
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

ChargePointsModal.propTypes = {
  configs: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  configs: state.coinsReducer.configs,
});

export default connect(mapStateToProps)(ChargePointsModal);
